module.exports = __webpack_public_path__ + "img/dwd1.03c97f36.png";